import cn from 'classnames'
import React, { useContext } from 'react'
import { AlignmentContext } from '../../../contexts/alignment-context'
import { usePageTheme } from '../../../contexts/page-theme-context'
import { TypeHorizontalAlignment } from '../../../lib/types/alignment'
import styles from './single-column.module.scss'

const alignmentStyleMap = {
  left: styles.alignLeft,
  right: styles.alignRight,
  default: styles.alignDefault,
  centerContentLeftAlignText: styles.alignCenterTextLeft,
}

export const getAlignmentStyle = (alignment: TypeHorizontalAlignment) => {
  return alignmentStyleMap[alignment]
}

export const SingleColumnLayout: React.FC<{ children?: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  const { horizontal } = useContext(AlignmentContext)
  const { pageWidth } = usePageTheme()

  return (
    <div
      className={cn(
        styles.content,
        className,
        pageWidth === '1280' ? styles.singleCol1280 : styles.singleCol1080,
        getAlignmentStyle(horizontal)
      )}
    >
      {children}
    </div>
  )
}
